export function escapeHtml(value) {
  return String(value ?? "")
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#39;");
}

export function normalizeDateKey(value) {
  const raw = String(value || "").trim();
  if (!raw) {
    return "";
  }

  const isoMatch = raw.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (isoMatch) {
    return `${isoMatch[1]}-${isoMatch[2]}-${isoMatch[3]}`;
  }

  const looseMatch = raw.match(/^(\d{4})[./](\d{1,2})[./](\d{1,2})/);
  if (looseMatch) {
    const month = String(looseMatch[2]).padStart(2, "0");
    const day = String(looseMatch[3]).padStart(2, "0");
    return `${looseMatch[1]}-${month}-${day}`;
  }

  const parsed = Date.parse(raw);
  if (!Number.isNaN(parsed)) {
    return new Date(parsed).toISOString().slice(0, 10);
  }

  return raw;
}

export function formatDateTime(timestamp) {
  if (!timestamp) {
    return "-";
  }

  const date = new Date(timestamp);
  return `${date.toLocaleDateString()} ${date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}`;
}

export function formatWeekdayLabel(weekday) {
  const raw = String(weekday || "").trim();
  if (!raw) {
    return "";
  }

  const key = raw.toLowerCase();
  const map = {
    sun: "일요일",
    sunday: "일요일",
    mon: "월요일",
    monday: "월요일",
    tue: "화요일",
    tuesday: "화요일",
    wed: "수요일",
    wednesday: "수요일",
    thu: "목요일",
    thursday: "목요일",
    fri: "금요일",
    friday: "금요일",
    sat: "토요일",
    saturday: "토요일",
  };

  if (map[key]) {
    return map[key];
  }

  if (/^[0-6]$/.test(key)) {
    return [map.sun, map.mon, map.tue, map.wed, map.thu, map.fri, map.sat][Number(key)];
  }

  if (/[일월화수목금토]/.test(raw)) {
    return raw.includes("요일") ? raw : `${raw}요일`;
  }

  return raw;
}

export function formatDateWithWeekday(dateValue) {
  const raw = String(dateValue || "").trim();
  if (!raw) {
    return "";
  }

  const directDateMatch = raw.match(/^(\d{4})[-./](\d{1,2})[-./](\d{1,2})$/);
  if (directDateMatch) {
    const year = Number(directDateMatch[1]);
    const monthIndex = Number(directDateMatch[2]) - 1;
    const day = Number(directDateMatch[3]);
    const date = new Date(year, monthIndex, day);
    if (!Number.isNaN(date.getTime())) {
      const weekdayKey = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"][date.getDay()];
      const weekdayText = formatWeekdayLabel(weekdayKey);
      return weekdayText ? `${raw} (${weekdayText})` : raw;
    }
  }

  const parsed = Date.parse(raw);
  if (!Number.isNaN(parsed)) {
    const date = new Date(parsed);
    const weekdayKey = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"][date.getDay()];
    const weekdayText = formatWeekdayLabel(weekdayKey);
    return weekdayText ? `${raw} (${weekdayText})` : raw;
  }

  return raw;
}
